const science = [
  {
    path: '/science',
    name: 'science',
    meta: { title: '四川省科技型中小企业评估测试', node: 'science', reviewType: 2 },
    component: () => import('../views/science/index.vue')
  },
  {
    path: '/science_evaluation',
    name: 'science_evaluation',
    meta: { title: '四川省科技型中小企业评估测试', node: 'science', reviewType: 2, childNode: true },
    component: () => import('../views/science/evaluation.vue')
  },
  {
    path: '/science_result',
    name: 'science_result',
    meta: { title: '四川省科技型中小企业评估测试', node: 'science', reviewType: 2 },
    component: () => import('../views/science/result.vue')
  }
]

export default science;